import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Pagination,
  Box,
} from "@mui/material";
import { convertBase64ToFileAndView } from "../../helpers/Base64ToFile";
import { showToast } from "../../helpers/ToastifyHelper";
import { displayValue } from "../../helpers/TodayDate";

interface Column {
  header: string;
  field: string;
  className?: string;
  isPopup?: boolean;
}

interface Row {
  [key: string]: any;
}

interface TableProps {
  columns: Column[];
  data: Row[];
  recordsPerPage?: number;
  fetchCevreVeyaEglenceGetData: (
    yili: number,
    isPass?: boolean,
    gelirKodu?: number,
    gelirAltKodu?: number,
    eglenceYeriAdi?: string,
    gelirAciklamasi?: string
  ) => Promise<void>;
}

const TableComponent1: React.FC<TableProps> = ({
  columns,
  data,
  recordsPerPage = 5,
  fetchCevreVeyaEglenceGetData,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentRecords, setCurrentRecords] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const pages = Math.ceil(data.length / recordsPerPage);
    setTotalPages(pages);
  }, [data, recordsPerPage]);

  useEffect(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    setCurrentRecords(data.slice(indexOfFirstRecord, indexOfLastRecord));
    console.log(data);
  }, [currentPage, data, recordsPerPage]);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <TableContainer component={Paper}>
        <Table className="border" size="small" aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  style={{
                    verticalAlign: "middle",
                    borderRight: "1px solid #ddd",
                  }}
                  className={`text-center ${column.className}`}
                >
                  {column.header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRecords.length !== 0 ? (
              currentRecords.map((item, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column, colIndex) =>
                    column.isPopup ? (
                      <TableCell
                        className={column.className}
                        key={colIndex}
                        style={{
                          verticalAlign: "middle",
                          fontSize: "1rem",
                          padding: "0.4rem",
                          borderRight: "1px solid #ddd",
                        }}
                      >
                        <Button
                          sx={{ px: 0.2, py: 0.2 }}
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            fetchCevreVeyaEglenceGetData(
                              item.yili,
                              false,
                              item.gelirKodu,
                              item.gelirAltKodu,
                              item.eglenceYeriAdi,
                              item.gelirAciklamasi
                            )
                          }
                          size="small"
                        >
                          Detay
                        </Button>
                      </TableCell>
                    ) : (
                      <TableCell
                        style={{
                          fontSize: "0.95rem",
                          verticalAlign: "middle",
                          borderRight: "1px solid #ddd",
                        }}
                        className={column.className}
                        key={colIndex}
                      >
                        {displayValue(item[column.field])}
                      </TableCell>
                    )
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  style={{
                    fontSize: "1.0rem",
                    padding: "0.5rem",
                    verticalAlign: "middle",
                    borderRight: "1px solid #ddd",
                  }}
                  colSpan={columns.length}
                >
                  Kayıt Bulunamadı.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={2} display="flex" justifyContent="center">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </div>
  );
};

export default TableComponent1;
